<template>
  <article class="plan-link-block">
    <h3 class="solgan px-22px py-0">
      美業歐巴幫你解決經營大小事<br />
      工作室、連鎖品牌都在用的美業預約系統
    </h3>

    <div class="btn-container">
      <router-link
        :to="{ name: 'Features', params: { name: 'suck-customer-tool' } }"
        class="link-btn bg-white text-primary-100"
        >了解更多</router-link
      >
      <router-link :to="{ name: 'PlanContent' }" class="link-btn text-white"
        >查看方案</router-link
      >
    </div>
  </article>
</template>

<script setup></script>

<style scoped lang="postcss">
.plan-link-block {
  @apply bg-primary-100 py-[32px] mt-[52px];
  @apply tablet: (mt-[72px] py-[46px]);
}

.solgan {
  @apply text-white font-bold text-[20px] leading-[28.96px] tracking-[2px];
  @apply tablet: (text-[40px] leading-[57.92px]);
}

.btn-container {
  @apply flex flex-col items-center gap-[16px] mt-[18px];
  @apply tablet: (flex-row justify-center gap-[104px] mt-[32px]);
}

.link-btn {
  @apply leading-[28.96px] text-[20px] font-medium;
  @apply w-[fit-content] border border-white rounded-[40px] py-[5px] px-[16px];
  @apply tablet: (text-[28px] py-[24px] px-[38px]);
}
</style>
